<template>
	<div>
		<div class="jbcl-block">
			<div class="jbcl-box" v-for="(item, index) in dataList" :key="index" @mouseover="moveIn(index)" @mouseleave="moveOut(index)" @click="toDetails(item.id)">
				<img :src="$imgUrl + item.listImgPc" alt="">
				<div class="jbcl-title">
					{{item.title}}
				</div>
				<transition name="fold">
					<div class="jbcl-details" v-show="moveIndex === index">
						<div class="title">
							{{item.title}}
						</div>
						<div class="content">
							{{item.shortTitle}}
						</div>
					</div>
				</transition>
			</div>
		</div>
		<page :pageObj="params" style="margin-bottom: 80px;" @getDataList="getData" ref="page"></page>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page
		},
		data () {
			return {
				moveIndex: "",
				dataList: [],
				params: {
					current: 1,
					size: 6,
					channelId: this.$store.state.channelId,
					releaseTerrace: "releasePc"
				}
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_2.png'
		},
		methods: {
			getData(dataList) {
				this.dataList = dataList
				this.$forceUpdate()
			},
			moveIn(index) {
				this.moveIndex = index
			},
			moveOut() {
				this.moveIndex = ""
			},
			toDetails(zlg_id) {
				this.$router.push({
					path: '/basic_display_details',
					query: {
						zlg_id: zlg_id,
						from: 'displayList'
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>

	.jbcl-block {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 1100px;
		margin: 0 auto 90px;
		.jbcl-box {
			width: 48%;
			position: relative;
			margin-top: 25px;
			cursor: pointer;
			overflow: hidden;
			img {
				height: 100%;
				width: 100%;
			}
			.jbcl-title {
				position: absolute;
				top: 28px;
				left: 5%;
				width: 90%;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: 24px;
				color: #FFFFFF;
				text-align: left;
			}
			.fold-enter-active {
			  animation-name: fold-in;
			  animation-duration: 1s;
			}
			.fold-leave-active {
			  animation-name: fold-out;
			  animation-duration: 1s;
			}
			@keyframes fold-in {
			  0% {
			    transform: translate3d(0, 100%, 0);
			  }
			  // 50% {
			  //   transform: translate3d(0, 50%, 0);
			  // }
			  100% {
			    transform: translate3d(0, 0, 0);
			  }
			}
			@keyframes fold-out {
			  0% {
			    transform: translate3d(0, 0, 0);
			  }
			  // 50% {
			  //   transform: translate3d(0, 50%, 0);
			  // }
			  100% {
			    transform: translate3d(0, 100%, 0);
			  }
			}
			.jbcl-details {
				position: absolute;
				width: 100%;
				left: 0;
				padding: 20px;
				height: 100%;
				background-color: rgba(0, 0, 0, 0.5);
				color: #FFFFFF;
				bottom: 0;
				overflow: hidden;
				.title {
					text-align: left;
					color: #FFFFFF;
					font-size: 20px;
					height: 37px;
					margin-top: 80px;
				}
				.content {
					color: #FFFFFF;
					text-align: left;
					font-size: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
				}
			}

		}
		// .jbcl-box:hover {
		// 	.jbcl-details {
		// 		position: absolute;
		// 		width: 100%;
		// 		padding: 20px;
		// 		left: 0;
		// 		background-color: rgba(0, 0, 0, 0.5);
		// 		color: #FFFFFF;
		// 		bottom: 0;
		// 		max-height: 110px;
		// 		.title {
		// 			text-align: left;
		// 			color: #FFFFFF;
		// 			font-size: 20px;
		// 			height: 37px;
		// 		}
		// 		.content {
		// 			color: #FFFFFF;
		// 			text-align: left;
		// 			font-size: 14px;
		// 			overflow: hidden;
		// 			text-overflow: ellipsis;
		// 			display: -webkit-box;
		// 			-webkit-line-clamp: 2;
		// 			line-clamp: 2;
		// 			-webkit-box-orient: vertical;
		// 		}
		// 	}
		// }
	}
	.ztzl-block {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 1100px;
		margin: 0 auto 90px;
		.ztzl-box {
			width: 48%;
			margin-top: 25px;
			display: flex;
			flex-direction: column;
			cursor: pointer;
			.ztzl-img {
				width: 100%;
				img {
					height: 100%;
					width: 100%;
				}
			}
			.ztzl-bottom {
				border: 3px solid #EDD68E;
				padding: 20px;
				width: 100%;
				height: 110px;
				background-color: #FFFFFF;
				display: flex;
				justify-content: space-between;
				.ztzl-left {
					width: 88%;
					.title {
						text-align: left;
						color: #264EA7;
						font-size: 13px;
						height: 26px;
					}
					.content {
						color: #686868;
						text-align: left;
						font-size: 9px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;
					}
				}
				.ztzl-right {
					width: 5%;
					color: #333333;
					i {
						font-size: 13px;
					}
				}
			}
		}
	}
	.ywzl-block {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 1100px;
		margin: 0 auto 90px;
		.ywzl-box {
			width: 48%;
			margin-top: 25px;
			display: flex;
			flex-direction: column;
			cursor: pointer;
			.ywzl-img {
				width: 100%;
				img {
					height: 100%;
					width: 100%;
				}
			}
			.ywzl-bottom {
				border: 3px solid #EDD68E;
				padding: 20px;
				width: 100%;
				height: 110px;
				background-color: #FFFFFF;
				.title {
					display: flex;
					justify-content: space-between;
					text-align: left;
					color: #264EA7;
					font-size: 13px;
					height: 26px;
					.title-left {
						width: 78%;
					}
					.title-right {
						width: 20%;
						text-align: right;
						color: #333333;
						i {
							margin-left: 5px;
						}
					}
				}
				.content {
					color: #686868;
					text-align: left;
					font-size: 9px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/exhibitions/displayList.vue